import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../axiosBaseQuery";


export interface InventoryOverViewPayload {
  dc: string[];
  itemId: [],
  productSegm: [],
  productDesc: [],
  category: [],
  subCategory: [],
  vendorName: []
}

export const InventoryOverviewApi = createApi({
  reducerPath: "InventoryOverviewApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    // Existing Graph Data mutation
    getGraphData: builder.mutation({
      query: (payload: InventoryOverViewPayload) => ({
        url: "/getInventoryOverviewBarChart",
        method: "POST",
        data: payload,
      }),
    }),

    getCardsData: builder.mutation({
        query: (payload: InventoryOverViewPayload) => ({
          url: "/getInventoryOverviewCardsData",
          method: "POST",
          data: payload,
        }),
      }),

    getMapGraphData: builder.mutation({
        query: (payload: InventoryOverViewPayload) => ({
          url: "/getInventoryoverViewMap",
          method: "POST",
          data: payload,
        }),
      }),

    // New Filter Data mutation
    getFilterData: builder.mutation({
      query: (payload: InventoryOverViewPayload) => ({
        url: "/forecastOverViewDropDownFilter", 
        method: "POST",
        data: payload,
      }),
    }),
  }),
});

// Export the hooks
export const {
  useGetGraphDataMutation, 
  useGetCardsDataMutation,
  useGetMapGraphDataMutation,
  useGetFilterDataMutation, 
} = InventoryOverviewApi;
